import React from 'react';
import '../styles/loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-heart-wrapper">
          {/* Circular ripple effects expanding outward */}
          <div className="heart-ripple ripple-1"></div>
          <div className="heart-ripple ripple-2"></div>
          <div className="heart-ripple ripple-3"></div>
          
          {/* Main Heart Shape (Full Red) */}
          <div className="heart-shape"></div>
        </div>
        
        {/* Animated progressive dots */}
        <div className="loader-progress-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        {/* Loading text */}
        <p className="loader-text">Finding your perfect match...</p>
      </div>
    </div>
  );
};

export default Loader;
